import React, { Component, Fragment } from 'react'
import tinymce from 'tinymce'
import autobind from 'autobind-decorator'
import './plugins/tistory-replacer'
import './plugins/tistory-attacher'
import './plugins/tistory-plugins'
import './plugins/tistory-mode'
import GooglePhotosDialog from "../plugins/GooglePhotos/GooglePhotosDialog";
import CategorySelect from "../CategorySelect";
import TemplateDialog from "./control/TemplateDialog";
import PostTitle from "../PostTitle";
import ContentEditor from "./ContentEditor";

const EDITOR_ID = 'editor-tistory';

class RichEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRng: {},
      openGooglePhotos: false,
      openTemplate: false,
    };
  }

  @autobind
  handleToggleGooglePhotos() {
    this.setState({
      openGooglePhotos: !this.state.openGooglePhotos
    })
  }

  @autobind
  handleToggleTemplate() {
    this.setState({
      openTemplate: !this.state.openTemplate
    })
  }

  @autobind
  handleApplyTemplate(content) {
    const { lastRng } = this.state;
    const editor = tinymce.activeEditor;
    editor.selection.setRng(lastRng);
    editor.execCommand('mceInsertContent', false, content);
    this.handleToggleTemplate();
  }

  @autobind
  handleOpenTemplate(rng) {
    this.setState({
      lastRng: rng
    });
    this.handleToggleTemplate();
  }

  render() {
    const { openGooglePhotos, openTemplate } = this.state;

    return (
      <Fragment>

        <CategorySelect />

        <PostTitle />

        <ContentEditor
          id={EDITOR_ID}
          onToggleGooglePhotos={this.handleToggleGooglePhotos}
          onOpenTemplate={this.handleOpenTemplate}
        />

        <GooglePhotosDialog
          open={openGooglePhotos}
          onClose={this.handleToggleGooglePhotos}
          onSelectImage={(url) => {
            console.log("select image", url)
          }}
        />

        <TemplateDialog
          open={openTemplate}
          onClose={this.handleToggleTemplate}
          onApply={this.handleApplyTemplate}
        />
      </Fragment>
    )
  }
}

export default RichEditor
